import { useAuth } from "@/contexts/AuthContext";
import { useEffect } from "react";
import { useLocation } from "wouter";
import { Spinner } from "@/components/ui/spinner";
import { EnhancedErrorBoundary } from "@/components/EnhancedErrorBoundary";

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole?: string;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading } = useAuth();
  const [, setLocation] = useLocation();

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      // Redirect ໄປໜ້າ login ຖ້າບໍ່ມີ authentication
      setLocation("/login");
    }
  }, [isAuthenticated, isLoading, setLocation]);

  // ຖ້າ loading ໃຫ້ render children ທັນທີ (ເພື່ອໃຫ້ DashboardLayout + bottom nav mount)
  // ແລ້ວ overlay spinner ໂປ່ງໃສ ເທິງ content ແທນ full-screen block
  if (isLoading) {
    return (
      <>
        {children}
        <div className="fixed inset-0 z-[9999] bg-white/60 backdrop-blur-sm flex items-center justify-center pointer-events-none">
          <Spinner className="h-10 w-10" />
        </div>
      </>
    );
  }

  // ຖ້າບໍ່ມີ authentication, ບໍ່ສະແດງຫຍັງ (ຈະ redirect ໃນ useEffect)
  if (!isAuthenticated) {
    return null;
  }

  // ຖ້າມີ authentication, ສະແດງ children ໃນ per-route ErrorBoundary
  // ປ້ອງກັນ crash ໃນ 1 page ທຳໃຫ້ page ອື່ນ crash ນຳ
  return <EnhancedErrorBoundary>{children}</EnhancedErrorBoundary>;
}
